import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectGlobalSearch = createSelector([(state: AppState) => state.admin.globalSearchRetrieval], ({ data, fetching }) => ({
  data,
  isLoading: fetching === "pending",
}));
